/* eslint-disable */
import React, { useState, useEffect } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';
import NotesManager from './NotesManager';

pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

function HomeletiquePage({ onGoBack, onOpenSettings }) {
  const [bibleSearchInput, setBibleSearchInput] = useState('');
  const [showNotes, setShowNotes] = useState(false);
  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);
  const [scale, setScale] = useState(1.0);
  const [showSidebar, setShowSidebar] = useState(true);

  const openChatGPT = () => {
    window.open('https://chatgpt.com/', '_blank', 'noopener,noreferrer');
  };

  const openBibleYouVersion = () => {
    window.open('https://www.bible.com/fr', '_blank', 'noopener,noreferrer');
  };

  const validateBibleSearch = () => {
    if (!bibleSearchInput.trim()) {
      alert('Veuillez entrer une référence (ex: Genèse 3:1)');
      return;
    }

    const bookMap = {
      'genèse': 'GEN', 'genese': 'GEN', 'exode': 'EXO', 'lévitique': 'LEV', 'levitique': 'LEV',
      'nombres': 'NUM', 'deutéronome': 'DEU', 'deuteronome': 'DEU', 'josué': 'JOS', 'josue': 'JOS',
      'juges': 'JDG', 'ruth': 'RUT', '1 samuel': '1SA', '2 samuel': '2SA', '1 rois': '1KI',
      '2 rois': '2KI', 'matthieu': 'MAT', 'marc': 'MRK', 'luc': 'LUK', 'jean': 'JHN',
      'actes': 'ACT', 'romains': 'ROM', '1 corinthiens': '1CO', '2 corinthiens': '2CO',
      'galates': 'GAL', 'éphésiens': 'EPH', 'ephesiens': 'EPH', 'philippiens': 'PHP',
      'colossiens': 'COL', 'apocalypse': 'REV'
    };

    const input = bibleSearchInput.toLowerCase().trim();
    const regex = /^([\w\sàâäéèêëïîôùûüç]+)\s+(\d+)(?::(\d+))?(?:-(\d+))?$/i;
    const match = input.match(regex);
    
    if (!match) {
      alert('Format incorrect. Ex: Genèse 3:1');
      return;
    }

    const bookName = match[1].trim();
    const chapter = match[2];
    const startVerse = match[3] || '';
    const endVerse = match[4] || '';
    const bookCode = bookMap[bookName];
    
    if (!bookCode) {
      alert(`Livre non reconnu: "${bookName}"`);
      return;
    }

    let verseParam = '';
    if (startVerse) {
      verseParam = `.${startVerse}`;
      if (endVerse) verseParam += `-${endVerse}`;
    }
    
    window.open(`https://www.bible.com/bible/93/${bookCode}.${chapter}${verseParam}.BDS`, '_blank');
  };

  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
  };

  const goToPrevPage = () => {
    setPageNumber(prev => Math.max(1, prev - 1));
  };

  const goToNextPage = () => {
    setPageNumber(prev => Math.min(numPages, prev + 1));
  };

  const zoomIn = () => {
    setScale(prev => Math.min(3.0, prev + 0.2));
  };

  const zoomOut = () => {
    setScale(prev => Math.max(0.5, prev - 0.2));
  };

  const goToPage = (page) => {
    setPageNumber(page);
  };

  // ===== STYLES =====
  
  const containerStyle = {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
    backgroundColor: '#525659',
    margin: 0,
    padding: 0,
    overflow: 'hidden',
    zIndex: 9999,
    display: 'flex',
    flexDirection: 'column'
  };

  const controlsBarStyle = {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    height: '60px',
    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '0 20px',
    boxShadow: '0 2px 10px rgba(0, 0, 0, 0.2)',
    zIndex: 10000,
    gap: '15px'
  };

  const leftControlsStyle = {
    display: 'flex',
    alignItems: 'center',
    gap: '10px'
  };

  const centerControlsStyle = {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    flex: 1,
    justifyContent: 'center'
  };

  const rightControlsStyle = {
    display: 'flex',
    alignItems: 'center',
    gap: '10px'
  };

  const controlBtnStyle = {
    background: 'rgba(255, 255, 255, 0.2)',
    border: '1px solid rgba(255, 255, 255, 0.3)',
    color: 'white',
    padding: '8px 16px',
    borderRadius: '8px',
    cursor: 'pointer',
    fontSize: '14px',
    fontWeight: '500',
    whiteSpace: 'nowrap',
    transition: 'all 0.2s ease'
  };

  const backBtnStyle = {
    background: 'rgba(102, 126, 234, 0.95)',
    color: 'white',
    border: '2px solid rgba(255, 255, 255, 0.3)',
    padding: '8px 16px',
    borderRadius: '8px',
    cursor: 'pointer',
    fontSize: '14px',
    fontWeight: '600'
  };

  const bibleSearchContainerStyle = {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    background: 'rgba(76, 175, 80, 0.3)',
    padding: '6px 16px',
    borderRadius: '20px',
    border: '1px solid rgba(255, 255, 255, 0.3)'
  };

  const bibleLabelStyle = {
    color: 'white',
    fontWeight: '600',
    fontSize: '13px',
    whiteSpace: 'nowrap'
  };

  const bibleInputStyle = {
    width: '200px',
    padding: '6px 12px',
    border: '2px solid rgba(255, 255, 255, 0.3)',
    borderRadius: '15px',
    background: 'rgba(255, 255, 255, 0.95)',
    fontSize: '13px',
    outline: 'none'
  };

  const bibleValidateBtnStyle = {
    background: 'white',
    color: '#4caf50',
    border: 'none',
    padding: '6px 16px',
    borderRadius: '15px',
    cursor: 'pointer',
    fontSize: '13px',
    fontWeight: '600'
  };

  const mainContentStyle = {
    display: 'flex',
    marginTop: '60px',
    height: 'calc(100vh - 60px)',
    overflow: 'hidden'
  };

  const sidebarStyle = {
    width: showSidebar ? '250px' : '0',
    backgroundColor: '#3a3a3a',
    overflowY: 'auto',
    overflowX: 'hidden',
    transition: 'width 0.3s ease',
    borderRight: showSidebar ? '2px solid #555' : 'none',
    padding: showSidebar ? '10px' : '0'
  };

  const thumbnailContainerStyle = {
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
    padding: '10px 0'
  };

  const thumbnailStyle = (page) => ({
    cursor: 'pointer',
    border: page === pageNumber ? '3px solid #667eea' : '2px solid #555',
    borderRadius: '4px',
    padding: '5px',
    backgroundColor: page === pageNumber ? '#555' : '#2a2a2a',
    transition: 'all 0.2s ease'
  });

  const thumbnailLabelStyle = {
    color: 'white',
    fontSize: '12px',
    textAlign: 'center',
    marginTop: '5px'
  };

  const pdfViewerStyle = {
    flex: 1,
    overflowY: 'auto',
    overflowX: 'auto',
    backgroundColor: '#525659',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'flex-start',
    padding: '20px'
  };

  const pageInfoStyle = {
    color: 'white',
    fontSize: '14px',
    fontWeight: '600',
    background: 'rgba(0, 0, 0, 0.5)',
    padding: '6px 12px',
    borderRadius: '15px'
  };

  const modalOverlayStyle = {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
    background: 'rgba(0, 0, 0, 0.7)',
    display: showNotes ? 'flex' : 'none',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 10002,
    backdropFilter: 'blur(5px)'
  };

  const modalContentStyle = {
    background: 'white',
    borderRadius: '16px',
    padding: '30px',
    maxWidth: '600px',
    width: '90%',
    maxHeight: '80vh',
    overflowY: 'auto',
    boxShadow: '0 10px 40px rgba(0, 0, 0, 0.3)'
  };

  return (
    <div style={containerStyle}>
      {/* Barre de contrôle */}
      <div style={controlsBarStyle}>
        {/* Gauche */}
        <div style={leftControlsStyle}>
          <button style={backBtnStyle} onClick={onGoBack || (() => window.history.back())}>
            ← Retour
          </button>
          <button style={controlBtnStyle} onClick={() => setShowSidebar(!showSidebar)}>
            {showSidebar ? '◀ Fermer' : '▶ Vignettes'}
          </button>
        </div>

        {/* Centre */}
        <div style={centerControlsStyle}>
          <button style={controlBtnStyle} onClick={zoomOut}>🔍−</button>
          <button style={controlBtnStyle} onClick={zoomIn}>🔍+</button>
          <button style={controlBtnStyle} onClick={goToPrevPage}>◀</button>
          <span style={pageInfoStyle}>
            {pageNumber} / {numPages || '...'}
          </span>
          <button style={controlBtnStyle} onClick={goToNextPage}>▶</button>

          {/* Recherche Bible intégrée */}
          <div style={bibleSearchContainerStyle}>
            <span style={bibleLabelStyle}>📖</span>
            <input
              type="text"
              placeholder="Ex: Genèse 3:1"
              style={bibleInputStyle}
              value={bibleSearchInput}
              onChange={(e) => setBibleSearchInput(e.target.value)}
              onKeyPress={(e) => e.key === 'Enter' && validateBibleSearch()}
            />
            <button style={bibleValidateBtnStyle} onClick={validateBibleSearch}>
              ✓
            </button>
          </div>
        </div>

        {/* Droite */}
        <div style={rightControlsStyle}>
          <button style={controlBtnStyle} onClick={openChatGPT}>💬 ChatGPT</button>
          {onOpenSettings && (
            <button style={controlBtnStyle} onClick={onOpenSettings}>⚙️ Paramètres</button>
          )}
          <button style={controlBtnStyle} onClick={() => setShowNotes(true)}>📝 Notes</button>
          <button style={controlBtnStyle} onClick={openBibleYouVersion}>📖 Bible</button>
        </div>
      </div>

      {/* Contenu principal */}
      <div style={mainContentStyle}>
        {/* Sidebar avec vignettes */}
        <div style={sidebarStyle}>
          {showSidebar && numPages && (
            <div style={thumbnailContainerStyle}>
              <Document
                file="/Homiletique-complet.pdf"
                loading={<div style={{color: 'white', padding: '10px'}}>Chargement...</div>}
              >
                {Array.from(new Array(numPages), (el, index) => (
                  <div key={`thumb_${index + 1}`} onClick={() => goToPage(index + 1)}>
                    <div style={thumbnailStyle(index + 1)}>
                      <Page
                        pageNumber={index + 1}
                        width={200}
                        renderTextLayer={false}
                        renderAnnotationLayer={false}
                      />
                      <div style={thumbnailLabelStyle}>Page {index + 1}</div>
                    </div>
                  </div>
                ))}
              </Document>
            </div>
          )}
        </div>

        {/* Viewer PDF principal */}
        <div style={pdfViewerStyle}>
          <Document
            file="/Homiletique-complet.pdf"
            onLoadSuccess={onDocumentLoadSuccess}
            loading={<div style={{color: 'white', padding: '40px', fontSize: '18px'}}>Chargement du PDF...</div>}
            error={<div style={{color: 'white', padding: '40px', fontSize: '18px'}}>Erreur de chargement</div>}
          >
            <Page
              pageNumber={pageNumber}
              scale={scale}
              renderTextLayer={true}
              renderAnnotationLayer={true}
            />
          </Document>
        </div>
      </div>

      {/* Modale Notes - Nouvelle version avec MongoDB */}
      {showNotes && (
        <NotesManager 
          context="Homilétique" 
          bibleReference={null}
          onClose={() => setShowNotes(false)} 
        />
      )}
    </div>
  );
}

export default HomeletiquePage;
